import entrepreneurImage from "@/assets/images/mulher_empreendedora.png";
import { Routes } from "@/constants/routes";
import { Button } from "@uigovpe/components";
import { useNavigate } from "react-router-dom";

type Props = {
  profileComplete?: boolean;
  performanceRaised?: boolean;
};

export default function OnboardingHero({
  profileComplete = false,
  performanceRaised = false,
}: Props) {
  const navigate = useNavigate();

  const content = !profileComplete
    ? {
        title: "Seu negócio merece visibilidade e crescimento!",
        description:
          "Complete seu perfil, cadastre seus produtos e facilite o contato de pessoas interessadas no que você faz.",
        primaryLabel: "Completar perfil",
        primaryAction: () => navigate(Routes.PROFILE),
        secondaryLabel: "Entenda como funciona",
        secondaryAction: undefined,
      }
    : performanceRaised
      ? {
          title: "Continue impulsionando o seu negócio",
          description:
            "Gerencie seus produtos, acompanhe sua visibilidade e fortaleça sua presença na plataforma.",
          primaryLabel: "Gerenciar minha vitrine",
          primaryAction: () => navigate(Routes.MY_PRODUCTS),
          secondaryLabel: "Adicionar produto",
          secondaryAction: () => navigate(Routes.ADD_PRODUCTS),
        }
      : {
          title: "Parabéns sua vitrine está no ar!",
          description:
            "Sua loja já está disponível para os clientes! Acompanhe suas métricas de desempenho e adicione novos produtos para impulsionar suas vendas.",
          primaryLabel: "Ver minha vitrine",
          primaryAction: () => {
            window.location.hash = "vitrine";
          },
          secondaryLabel: "Adicionar produto",
          secondaryAction: () => navigate(Routes.ADD_PRODUCTS),
        };

  return (
    <div className="grid! min-h-[280px]! grid-cols-1! overflow-hidden! rounded-2xl! md:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)]!">
      <div className="flex! flex-col! justify-center! bg-[#f3f0ff]! p-8! md:px-10! md:py-8!">
        <div
          key={`${profileComplete}-${performanceRaised}`}
          className="onboarding-hero-content-transition"
        >
          <h2 className="mt-0! mb-3! max-w-[25rem]! text-[1.50rem]! leading-[1.2]! font-bold! tracking-[-0.009rem]! text-[#4e3873]! md:text-[1.60rem]!">
            {content.title}
          </h2>
          <p className="mt-0! mb-6! max-w-[27rem]! text-[1.1rem]! leading-[1.5]! font-normal! text-[#28272c]!">
            {content.description}
          </p>
          <div className="flex flex-wrap gap-4">
            <Button
              className="h-[2.5rem]! min-h-[2.5rem]! min-w-[10.75rem]! border-[#4e3873]! bg-[#4e3873]! px-4! py-2! text-white! hover:border-[#351868]! hover:bg-[#351868]! [&_.p-button-label]:text-white!"
              label={content.primaryLabel}
              onClick={content.primaryAction}
            />
            <Button
              className="h-[2.5rem]! min-h-[2.5rem]! min-w-[10.75rem]! border-[#4e3873]! bg-white! px-4! py-2! text-[#4e3873]! hover:border-[#4e3873]! hover:bg-[#ccc2ff]! [&_.p-button-label]:text-[#4e3873]!"
              outlined
              label={content.secondaryLabel}
              onClick={content.secondaryAction}
            />
          </div>
        </div>
      </div>
      <div className="flex min-h-[220px] min-w-0 items-center justify-center overflow-hidden bg-[#d4cef7] md:min-h-[280px]">
        <img
          src={entrepreneurImage}
          alt="Mulher empreendedora trabalhando em seu negócio"
          className="h-full min-h-[220px] w-full object-cover md:min-h-[280px]"
        />
      </div>
    </div>
  );
}
